import * as React from 'react';

import { ContainerStatus } from '@rematter/frontend-lib-api-client';
import { Badge, cn, ThemeColor } from '@rematter/ui-web';

import { useTranslations } from '~/shared/i18n/useTranslations';

const statusVariants: Record<ContainerStatus, ThemeColor> = {
  AtPort: 'neutral',
  InTransitToFacility: 'warning',
  AtFacilityEmpty: 'neutral',
  AtFacilityLoaded: 'success',
  InTransitToPort: 'warning',
  AtPortReadyToShip: 'neutral',
  Shipped: 'success',
  Voided: 'failure',
};

export const ContainerStatusBadge: React.FC<{ status: ContainerStatus }> = ({
  status,
}) => {
  const t = useTranslations();

  const variant = statusVariants[status] || 'default';

  const statusLabels = React.useMemo<Record<ContainerStatus, string>>(
    () => ({
      AtPort: t.containerStatus.atPort,
      InTransitToFacility: t.containerStatus.inTransitToFacility,
      AtFacilityEmpty: t.containerStatus.atFacilityEmpty,
      AtFacilityLoaded: t.containerStatus.atFacilityLoaded,
      InTransitToPort: t.containerStatus.inTransitToPort,
      AtPortReadyToShip: t.containerStatus.atPortReadyToShip,
      Shipped: t.containerStatus.shipped,
      Voided: t.containerStatus.voided,
    }),
    [t],
  );

  const label = statusLabels[status];

  return (
    <Badge color={variant} className={cn('@ContainerStatusBadge')}>
      {label}
    </Badge>
  );
};
